<template>
  <canvas :class="canvasClass"></canvas>
</template>

<script setup>
import { randomRange } from '@/libs/tools'
import { onMounted, watch } from 'vue'
const props = defineProps({
  canvasWidth: {
    type: Number,
    default: 152,
  },
  lineWidth: {
    type: Number,
    default: 18,
  },
  canvasColor: {
    type: String,
  },
  canvasPercentage: {
    type: Number,
    default: 0,
  },
  chartCanvas: {
    type: String,
    default: 'chart-canvas',
  },
})

const canvasClass = 'canvas_' + randomRange(1, 9999)

// canvas定义
const canvasHandle = () => {
  const canvasWidth = props.canvasWidth
  let canvasDprWidth = props.canvasWidth
  const lineWidth = props.lineWidth
  const canvasColor = props.canvasColor
  const canvasPercentage = (2 * props.canvasPercentage) / 100 - 0.5
  // 根据屏幕dpi，同比放大canvas，防止绘图模糊
  const setupCanvas = (canvas, ctx) => {
    const width = canvasWidth
    const height = canvasWidth
    const dpr = window.devicePixelRatio || 1.0
    canvasDprWidth = canvasWidth * dpr
    // lineWidth = lineWidth * dpr
    canvas.style.width = width + 'px'
    canvas.style.height = height + 'px'
    canvas.height = canvasDprWidth
    canvas.width = canvasDprWidth
    if (dpr !== 1.0) {
      ctx.scale(dpr, dpr)
    }
  }
  const canvas = document.querySelector('.' + canvasClass)
  const ctx = canvas.getContext('2d')
  setupCanvas(canvas, ctx)
  const r = canvasWidth / 2 - lineWidth
  ctx.lineCap = 'round'
  ctx.lineWidth = lineWidth
  var gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height)
  gradient.addColorStop(0.99, '#EFEFEF') // 渐变起始颜色
  gradient.addColorStop(1, '#fff') // 渐变结束颜色
  // ctx.strokeStyle = '#f4f4f4'
  ctx.strokeStyle = gradient
  ctx.arc(canvasWidth / 2, canvasWidth / 2, r, -0.5 * Math.PI, 1.5 * Math.PI, false)
  ctx.stroke()

  ctx.beginPath()
  ctx.lineCap = 'round'
  ctx.lineWidth = lineWidth
  ctx.strokeStyle = canvasColor
  ctx.arc(canvasWidth / 2, canvasWidth / 2, r, -0.5 * Math.PI, canvasPercentage * Math.PI, false)
  ctx.stroke()

  // 绘制一个白点
  ctx.beginPath()
  ctx.strokeStyle = 'rgba(255,255,255, 1)'
  ctx.arc(canvasWidth / 2, canvasWidth / 2, r, canvasPercentage * Math.PI, canvasPercentage * Math.PI, false)
  ctx.stroke()

  // 白点的中心绘制一个小点
  ctx.beginPath()
  ctx.lineWidth = lineWidth / 3
  ctx.strokeStyle = canvasColor
  ctx.arc(canvasWidth / 2, canvasWidth / 2, r, canvasPercentage * Math.PI, canvasPercentage * Math.PI, false)
  ctx.stroke()

  ctx.save()
}
// 如果百分比发生变化，重新绘制canvas
watch(
  () => props.canvasPercentage,
  () => {
    canvasHandle()
  }
)

onMounted(() => {
  canvasHandle()
})
</script>
